import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { CHECK, CHECK_CIRCLE, SMALL_THREE, SMALL_TWO, SUCCESS_CHECK } from '../../../assets'
import { ImageComp } from '../../../components/Image/Image'
import { useCssStyle } from '../../../customHook/getCssStyle'
import { useTranslation } from 'react-i18next'
import CustomPressable from '../../../components/customPressable/customPressable'
import HeaderWithBack from '../../../components/Header/headerWithBack'

const VerifiedSuccessScreen = (props) => {
    const { handleNext, handleGoBack, handleCancel } =  props;

    const getStyles = useCssStyle();
    const {t} = useTranslation();

    return (
        <View id='widgetRootContainer' style={getStyles(['widgetRootContainer'])}>
            <HeaderWithBack hideBackButton={true} handleCustomBackPress={handleGoBack} handleCustomCancelClick={handleCancel} />


            <ScrollView id='widgetmainContainer idVerificationSuccessMainContainer' contentContainerStyle={getStyles(['widgetmainContainer', 'idVerificationSuccessMainContainer'])} showsVerticalScrollIndicator={false} >
                <View id='widgetmainContainerHeaderContainer idVerificationSuccessHeaderContainer' style={getStyles(['widgetmainContainerHeaderContainer', 'idVerificationSuccessHeaderContainer'])}>
                    <View id='idVerificationSuccessContainerHeaderImgContainer' style={getStyles(['idVerificationSuccessContainerHeaderImgContainer'])}>
                        <ImageComp id="idVerificationSuccessContainerHeaderImg" source={SUCCESS_CHECK} style={getStyles(['idVerificationSuccessContainerHeaderImg'])} />
                    </View>

                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'idVerificationSuccesspreCheckInHeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer idVerificationSuccesspreCheckInHeaderTitleContainer' >
                        <Text id='widgetmainContainerHeaderTitle idVerificationSuccessMainContainerChildContainer_infotext' style={getStyles(['widgetmainContainerHeaderTitle', 'idVerificationSuccessMainContainerChildContainer_infotext'])}>
                            {t('check_in.id_verification.verify_success_heading')}
                        </Text>

                        <Text id='widgetmainContainerHeaderSubTitle idVerificationSuccessMainContainerChildContainer_subinfotext' style={getStyles(['widgetmainContainerHeaderSubTitle', 'idVerificationSuccessMainContainerChildContainer_subinfotext'])}>
                            {t('check_in.id_verification.verify_success_subheading')}
                        </Text>
                    </View>
                </View>

                <View style={getStyles(['idVerificationSuccessMainContainerChildContainer_buttonContainer'])} id='idVerificationSuccessMainContainerChildContainer_buttonContainer'>
                    <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleNext}>
                        <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.id_verification.primary_button_success')}</Text>
                    </CustomPressable>
                </View>
            </ScrollView>
        </View>
    )
}

export default VerifiedSuccessScreen
